<template>
  <div id="textarea-components">
    <div class="form-group">
      <label v-if="label !== ''" :for="name"> {{ label }} </label>
      <textarea
        :id="`${name}-${index || ''}`"
        :value="modelValue"
        class="form-control"
        :class="`form-control-${size} ${
          fieldState === false ? 'is-invalid' : ''
        }`"
        :name="name"
        :placeholder="placeholder"
        :rows="rows"
        :readonly="isDisable"
        :state="$hasField({ name, errors, index, parent })"
        @blur="$emit('blurEvent', name, index)"
        @input="$emit('update:modelValue', $event.target.value)"
      ></textarea>
      <!-- display error messages -->
      <error-message-new
        v-if="!$hasField({ name, errors, index, parent }) && showError"
        :index="index"
        :errors="errors"
        :fieldName="name"
        :parent="parent"
      />
    </div>
  </div>
</template>

<script>
import { $hasField } from "@/helper/globalFunction.js";
import { handleFieldState } from "@/helper/fieldStateHandler";

export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      default: null,
    },
    placeholder: {
      type: String,
      required: true,
    },
    modelValue: {
      type: [String, Number],
    },
    size: {
      type: String,
      default: "sm",
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    showError: {
      type: Boolean,
      default: true,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    parent: {
      type: String,
      default: "",
    },
    logic: {
      type: Object,
      default: () => ({})
    },
    rows: {
      type: String,
      default: "3",
    },
    maxRows: {
      type: String,
      default: null,
    },
    content: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: { $hasField, handleFieldState },
};
</script>

<style></style>
